import { useState } from 'react'
import { Helmet } from 'react-helmet'
import { TabMenu } from '../../../components/BaseComponents'
import PageHeadings from '../../../components/BaseComponents/PageHeadings/PageHeadings'
import PageTemplate from '../../../components/BaseComponents/PageTemplate/PageTemplate'
import { routes } from '../../../components/Router/routes'
import ECO2SectorGraph from './Graphs/ECO2Sector'
import ECO2SupplierGraph from './Graphs/ECO2Supplier'
import IntensitySupplierGraph from './Graphs/IntensitySupplierGraph'

const CompanyInsightsSupplyChainAnalysisPage = () => {
	const [embeddedTab, setEmbeddedTab] = useState('sector')
	const [sectorIds, setSectorIds] = useState<number | undefined>(undefined)
	const drillDownToSupplier = (val: any) => {
		setSectorIds(val)
		setEmbeddedTab('supplier')
	}
	const resetToSector = () => {
		setSectorIds(undefined)
		setEmbeddedTab('sector')
	}
	return (
		<>
			<PageTemplate testid='company-dashboard-main'>
				<Helmet>
					<title>{routes.companyInsightsSupplyChainAnalysis.name}</title>
				</Helmet>
				<PageHeadings crumbs={[{ label: routes.companyInsightsSupplyChainAnalysis.menuName as string }]} />

				<TabMenu
					ariaLabel='Supply chain analysis'
					additionalClass='mt-8'
					tabs={[
						{
							id: 'embedded',
							label: 'Embedded CO₂e',
							panel: (active) => (
								<>
									{active && (
										<TabMenu
											ariaLabel='Embedded CO₂e views'
											orientation='vertical'
											additionalClass='mt-4'
											additionalPanelClass='p-4'
											value={embeddedTab}
											onChange={setEmbeddedTab}
											tabs={[
												{
													id: 'sector',
													label: 'Embedded CO₂e in Purchases by Sector',
													panel: (active) => <>{active && <ECO2SectorGraph onChangeInitialActiveTab={drillDownToSupplier} />}</>,
												},
												{
													id: 'supplier',
													label: 'Embedded CO₂e in Purchases by Supplier',
													panel: (active) => <>{active && <ECO2SupplierGraph sectorIds={sectorIds} updateSectorId={resetToSector} />}</>,
												},
											]}
										/>
									)}
								</>
							),
						},
						{
							id: 'intensity',
							label: 'Carbon Intensity',
							panel: (active) => (
								<>
									{active && (
										<TabMenu
											ariaLabel='Carbon intensity views'
											orientation='vertical'
											additionalClass='mt-4'
											additionalPanelClass='p-4'
											tabs={[
												{
													id: 'supplier',
													label: 'Intensity ratio by Supplier',
													panel: (active) => <>{active && <IntensitySupplierGraph sectorIds={sectorIds} updateSectorId={resetToSector} />}</>,
												},
											]}
										/>
									)}
								</>
							),
						},
					]}
				/>
			</PageTemplate>
		</>
	)
}
export default CompanyInsightsSupplyChainAnalysisPage
